var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 362.429 362.429",
    style: {
      enableBackground: "new 0 0 362.429 362.429"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 136.058,
    y: 27.122,
    style: {
      fill: "#FFDE55"
    },
    width: 16.433,
    height: 48.818
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.813,
    y: 62.228,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 329.7162 309.8465)",
    style: {
      fill: "#FFDE55"
    },
    width: 16.433,
    height: 48.818
  }), /*#__PURE__*/React.createElement("rect", {
    y: 163.179,
    style: {
      fill: "#FFDE55"
    },
    width: 48.818,
    height: 16.433
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.108,
    y: 78.422,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 40.3388 189.985)",
    style: {
      fill: "#FFDE55"
    },
    width: 48.818,
    height: 16.433
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDE55"
    },
    d: "M144.272,93.022c-43.285,0-78.374,35.09-78.374,78.375c0,43.284,35.09,78.374,78.374,78.374 s78.374-35.09,78.374-78.374C222.647,128.113,187.557,93.022,144.272,93.022"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#57C3FF"
    },
    d: "M362.429,274.566c0,4.95-0.59,9.75-1.71,14.35c-6.44,26.62-30.43,46.39-59.041,46.39H78.189 c-16.77,0-31.96-6.801-42.95-17.79c-10.99-10.99-17.79-26.17-17.79-42.95c0-33.55,27.19-60.75,60.74-60.75h4.36 c2.53-16.97,11.12-31.97,23.5-42.73c12.37-10.76,28.53-17.27,46.21-17.27c7.77,0,15.24,1.28,22.23,3.6 c7.33-9.65,16.8-17.58,27.69-23.11c2.88-1.46,5.86-2.75,8.93-3.86c8.53-3.09,17.74-4.78,27.34-4.78c44.35,0,80.3,35.95,80.3,80.3 v10.301c12.62,3.69,23.54,11.36,31.31,21.56C357.819,248.026,362.429,260.756,362.429,274.566"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59B6E9"
    },
    d: "M238.449,125.666c-9.599,0-18.809,1.69-27.339,4.78c0,0,0,0-0.001,0l149.61,158.47 c1.12-4.6,1.71-9.4,1.71-14.35c0-13.81-4.61-26.54-12.37-36.74c-7.77-10.2-18.69-17.87-31.31-21.56v-10.301 C318.749,161.617,282.799,125.666,238.449,125.666"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.36130124769f4cd9378d19c17210a622.svg";
export { ForwardRef as ReactComponent };